import { NavList } from '@components/NavList/NavList';
import { KitNamedLink } from '@services/kits/kit';
import { KitItemLink } from './KitItemLink';

interface KitsTabProps {
  kits: KitNamedLink[];
}

export function KitsTab({ kits }: Readonly<KitsTabProps>) {
  return (
    <NavList>
      {kits.map((kit) => (
        <KitItemLink kit={kit} key={kit.url} />
      ))}
    </NavList>
  );
}
